import Indicador from "..";
import PerdasEditFields from "./components/PerdasEditFields";
// import PerdasGraficoExtraPainel from "./components/PerdasGraficoExtraPainel";
// import PerdasGraficoExtraRelatorio from "./components/PerdasGraficoExtraRelatorio";
import { PerdasParamFields } from "./components/PerdasParamFields";
import perdasReport from "./reports";
import perdasReportSummary from "./reports/summary";

export default class Perdas extends Indicador {
    static get fullName() {
        return "Perdas";
    }

    static get abbrev() {
        return "Perdas";
    }

    static get field() {
        return "perd";
    }

    static get legacyApontamentoMap() {
        return {
            dataHoraNGV: {
                newField: "date",
                convert: this.parseLegacyDate,
            },

            tipo: "tipo",
            talhao: "talhao",
            frente: "frente",

            insumo: "insumo",
            tch: "tch",
            equipe: "equipamento",
            turno: "turno",
            georeferencia: "georeferencia",

            toco: "toco",
            ponteiro: "ponteiro",
            canaInteira: "canaInteira",
            canaFixa: "canaFixa",
            estilhaco: "estilhaco",
            tolete: "tolete",
            pedaco: "pedaco",

            totalPerdas: "totalPerdas",
            conformidadeAmostra: "conformidade",

            observacaoAmostra: "observacao",

            itensColeta: "images",
        };
    }

    static get legacyParamMap() {
        return {
            perdasMetaManual: "manual.meta",

            perdasMetaMecanizado: "mecanizado.meta",
        };
    }

    static paramFields(tipoIndicadorField = "") {
        return <PerdasParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PerdasEditFields visita={visita} isNew={isNew} TipoClass={TipoClass} />;
    }

    // static getGraficoExtraPainel(indicadorProps, nomeAgrupador) {
    //     return <PerdasGraficoExtraPainel indicadorProps={indicadorProps} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim) {
    //     return PerdasGraficoExtraRelatorio(content, h, mediaAgrupadorList, metaUsar, IndicadorEntity, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim)
    // }

    async renderReport(visita) {
        return perdasReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return perdasReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!params) {
            return 0;
        }

        const toco = f(apontamento.toco) || 0;
        const tocoIndireto = f(apontamento.tocoIndireto) || 0;
        const ponteiro = f(apontamento.ponteiro) || 0;
        const canaInteira = f(apontamento.canaInteira) || 0;
        const canaFixa = f(apontamento.canaFixa) || 0;
        const estilhaco = f(apontamento.estilhaco) || 0;
        const tolete = f(apontamento.tolete) || 0;
        const pedaco = f(apontamento.pedaco) || 0;
        const lasca = f(apontamento.lasca) || 0;
        const toleteEstilhacado = f(apontamento.toleteEstilhacado) || 0;

        apontamento.totalPerdas = (
            toco +
            tocoIndireto +
            ponteiro +
            canaInteira +
            canaFixa +
            estilhaco +
            tolete +
            pedaco +
            lasca +
            toleteEstilhacado
        ).toFixed(0);

        let perdas = 0;
        const divisor = f(apontamento.tch) * 1000;

        if (divisor) {
            perdas = Math.min((f(apontamento.totalPerdas) / divisor) * 100, 100);
        }

        apontamento.acima = perdas > f(params.meta) ? 1 : 0;
        apontamento.abaixo = 0;

        return perdas.toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 117.05, 100, 83.61);
    }
    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frente", field: "frente", width: "auto" },
            { title: "Turno", field: "turno", width: "auto" }, //
            {
                title: "Operador",
                width: "auto",
                getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador;
                    if (typeof a.operador === "string" && a.operador) return a.operador;
                    return "-";
                },
            },

            { title: "Variedade", field: "insumo.nome" },
            { title: "TCH", field: "tch", width: "auto" },
            { title: "Equip.", field: "equipamento.equipamento", width: "auto" },
            { title: "Toco (g)", field: "toco", width: 20 },
            { title: "Toco Indireto (g)", field: "tocoIndireto", width: 30 },
            { title: "Ponteiro (g)", field: "ponteiro", width: 35 },
            { title: "Cana Inteira (g)", field: "canaInteira", width: 30 },
            { title: "Cana/Pedaço Fixo (g)", field: "canaFixa", width: 30 },
            { title: "Estilhaço (g)", field: "estilhaco", width: 38 },
            { title: "Tolete (g)", field: "tolete", width: 30 },
            { title: "Pedaço (g)", field: "pedaco", width: 30 },
            { title: "Lasca (g)", field: "lasca", width: 25 },
            { title: "Tolete Estilhaçado (g)", field: "toleteEstilhacado", width: 25 },
            { title: "Total Perdas (g)", field: "totalPerdas", width: 30 },

            {
                title: "Perdas(%)",
                field: "conformidade",
                width: 30,
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        let variedade = apontamento.insumo && apontamento.insumo.nomeInsumo ? apontamento.insumo.nomeInsumo : "";

        return (
            "Variedade: " +
            variedade +
            ", TCH: " +
            apontamento.tch +
            ", Equipamento: " +
            (apontamento.equipamento ? apontamento.equipamento.equipamento : "") +
            ", Toco (g): " +
            apontamento.toco +
            ", Toco Indireto (g): " +
            apontamento.tocoIndireto +
            ", Ponteiro (g): " +
            apontamento.ponteiro +
            ", Cana Inteira (g): " +
            apontamento.canaInteira +
            ", Cana/Pedaço Fixo (g): " +
            apontamento.canaFixa +
            ", Estilhaço (g): " +
            apontamento.estilhaco +
            ", Tolete (g): " +
            apontamento.tolete +
            ", Pedaço (g): " +
            apontamento.pedaco +
            ", Lasca (g): " +
            apontamento.lasca +
            ", Tolete Estilhaçado (g): " +
            apontamento.toleteEstilhacado +
            " e Total Perdas (g): " +
            apontamento.totalPerdas
        );
    }
}
